export const isAdminLoginPath = pathname => pathname === '/' || pathname === '/login';

export function getAdminLoginDestination(user) {
    if (user?.role === 'SUPER') return '/dashboard';
    if (user?.wallet_use_yn === 'Y') return '/agentDashboard';
    return '/paylist';
}
